"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllDriversUniqueValidation = void 0;
var InteractionHelper_1 = require("../helpers/InteractionHelper");
var FalconValidationMethodBase_1 = require("./FalconValidationMethodBase");
/**
 * Validates that there are no duplicate drivers
 */
var AllDriversUniqueValidation = /** @class */ (function (_super) {
    __extends(AllDriversUniqueValidation, _super);
    function AllDriversUniqueValidation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllDriversUniqueValidation.prototype.validateInput = function (input, context) {
        var interaction = this.getInteraction(context);
        if (!interaction) {
            return this.validResult();
        }
        var allDrivers = InteractionHelper_1.InteractionHelper.getAllDrivers(interaction);
        if (!allDrivers || allDrivers.length === 0) {
            return this.validResult();
        }
        var duplicatesFound = allDrivers.some(function (d1) {
            var d1Duplicates = allDrivers.filter(function (d2) { return InteractionHelper_1.InteractionHelper.driversEqual(d1, d2); });
            return d1Duplicates.length > 1;
        });
        if (duplicatesFound) {
            return this.invalidResult(this.getErrorMessage(context, "There are duplicate drivers"));
        }
        return this.validResult();
    };
    return AllDriversUniqueValidation;
}(FalconValidationMethodBase_1.FalconValidationMethodBase));
exports.AllDriversUniqueValidation = AllDriversUniqueValidation;
//# sourceMappingURL=AllDriversUniqueValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/AllDriversUniqueValidation.js
// module id = 2535
// module chunks = 0